export default "__VITE_ASSET__BkePCHRs__"